import { GliderFileType } from '@/enum/GliderFileType'
import { IAloBaseArray, AloBaseArray } from './AloBaseArray';

export class FileNameAnalysisResult  {
  public isValidFilename: boolean
  public errorDigest: string
  public errorData: any
  public fileName: string
  public gliderFileType?: GliderFileType
  public gliderKey: string
  public misIdx?: number
  public misId?: number
  public gliId?: number
  public yosCycle?: number
  public isCompressed?: boolean

  constructor({ isValidFilename, errorDigest, errorData,fileName,gliderFileType,gliderKey,misIdx,misId,gliId,yosCycle,isCompressed}: {isValidFilename: boolean,errorDigest: string,errorData: any, fileName:string, gliderFileType?:GliderFileType,gliderKey:string,misIdx?:number,misId?:number,gliId?:number,yosCycle?:number,isCompressed?:boolean}) {
    this.isValidFilename = isValidFilename
    this.errorDigest = errorDigest
    this.errorData = errorData
    this.fileName = fileName
    this.gliderFileType = gliderFileType
    this.gliderKey = gliderKey
    this.misIdx = misIdx
    this.misId = misId
    this.gliId = gliId
    this.yosCycle = yosCycle
    this.isCompressed = isCompressed
  }  

  static createFileNameAnalysisResult(data:any) {
    return new FileNameAnalysisResult(data)
  }
}
